import { useState } from 'react';
import { Button, Group, MultiSelect, TextInput } from '@mantine/core';

import { IconSearch } from '@tabler/icons-react';
import type { DefaultOptionsParams } from './useEnrollmentSearchBarParams';
import { useEnrollmentSearchBarParams } from './useEnrollmentSearchBarParams';
import {
  TICKET_TYPE_CONFIG,
  TICKET_TYPE,
} from '#/components/ui/tickets/config';
import {
  ENROLLMENT_TYPE_VALUE,
  PAY_INTERVAL_LABEL,
  PAY_INTERVAL_VALUE,
  PayIntervalValue,
} from '../../model';

const SERVICE_TYPE_OPTIONS = ENROLLMENT_TYPE_VALUE.map((value) => ({
  value,
  label: TICKET_TYPE_CONFIG[value].name,
}));

const INTERVAL_TYPE_OPTIONS: Array<{
  value: PayIntervalValue;
  label: string;
}> = PAY_INTERVAL_VALUE.map((value) => ({
  value,
  label: PAY_INTERVAL_LABEL[value],
}));

export type EnrollmentSearchBarProps = {
  defaultOptions: DefaultOptionsParams;
};

export function EnrollmentSearchBar({
  defaultOptions,
}: EnrollmentSearchBarProps) {
  const { params, setType, setInterval, setFuzzySearchText, reset } =
    useEnrollmentSearchBarParams(defaultOptions);
  const [inputSearchValue, setSearchInputValue] = useState(
    () => params.fuzzySearchText ?? '',
  );

  return (
    <Group gap="sm">
      <TextInput
        flex={1}
        value={inputSearchValue}
        onChange={(e) => {
          setFuzzySearchText(e.target.value);
          setSearchInputValue(e.target.value);
        }}
        type="text"
        placeholder="搜尋 Email、車牌、證件號碼 / 統編"
        leftSection={<IconSearch size={16} />}
      />
      <MultiSelect
        w={200}
        data={SERVICE_TYPE_OPTIONS}
        placeholder={params.type.length < 1 ? '請選擇服務類型' : undefined}
        clearable
        value={params.type}
        renderPill={({ option }) => {
          if (option.value !== params.type[0]) return null;
          if (params.type.length > 1) return '...';
          return option.label;
        }}
        onChange={(v) => {
          setType(v as TICKET_TYPE[]);
        }}
      />
      <MultiSelect
        w={160}
        data={INTERVAL_TYPE_OPTIONS}
        placeholder={params.interval.length < 1 ? '請選擇查詢週期' : undefined}
        clearable
        value={params.interval}
        renderPill={({ option }) => {
          if (option.value !== params.interval[0]) return null;
          if (params.interval.length > 1) return '...';
          return option.label;
        }}
        onChange={(v) => {
          setInterval(v as PayIntervalValue[]);
        }}
      />
      <Button variant="default" onClick={reset}>
        重設
      </Button>
    </Group>
  );
}
